import {UserConfig} from "../types/UserConfig";

export function buildColumnDefs(userConfig: UserConfig) {
    return [
        {
            name: "call.option.code",
            type: "string",
            displayName: "Code",
            width: "*",
            headerCellClass: "pt-5",
            headerCellTemplate: `<span>ASX Code</span> <i class="icon-question text-grey" uib-popover="The ASX code is the unique name provided by the exchange for identification purposes." popover-trigger="'mouseenter'" popover-placement="bottom" ></i>`,
            cellTemplate: `<div class="ui-grid-cell-contents" ng-class="{itm : row.entity.call.itm, selectedOption : row.entity.call.option.code === grid.appScope.selectedInstrument.code}" ng-click="grid.appScope.selectInstrument(row.entity.call.option)" ng-dblclick="grid.appScope.doubleSelectInstrument(row.entity.call.option)">{{row.entity.call.option.code}}</div>`
        },
        {
            name: "call.price.p",
            type: "number",
            displayName: "Theo Price",
            width: "*",
            cellFilter: "number : 3",
            visible: true,
            cellTemplate: `<div class="ui-grid-cell-contents gridNumber" ng-class="{itm : row.entity.call.itm, selectedOption : row.entity.call.option.code === grid.appScope.selectedInstrument.code}" ng-click="grid.appScope.selectInstrument(row.entity.call.option)" ng-dblclick="grid.appScope.doubleSelectInstrument(row.entity.call.option)">{{row.entity.call.price.p | number : 3}}</div>`
        },
        {
            name: "call.spread.quote",
            type: "number",
            displayName: "Quote",
            width: "*",
            cellFilter: "number : 0",
            visible: userConfig.livePrices,
            cellTemplate: `<div class="ui-grid-cell-contents gridNumber" ng-class="{itm : row.entity.call.itm, selectedOption : row.entity.call.option.code === grid.appScope.selectedInstrument.code}" ng-click="grid.appScope.selectInstrument(row.entity.call.option)" ng-dblclick="grid.appScope.doubleSelectInstrument(row.entity.call.option)"><div class="chain-quote-cell"><span class="quote-bid">{{(row.entity.call.spread.b | strategyPrice: grid.appScope.priceStrategy : true) || '-'}}</span><span class="quote-divider">/</span><span class="quote-ask">{{(row.entity.call.spread.a | strategyPrice : grid.appScope.priceStrategy : true) || '-'}}</span></div></div>`
        },
        {
            name: "call.price.v",
            type: "number",
            displayName: "Volatility",
            width: "*",
            cellFilter: "percentage : 2",
            cellTemplate: `<div class="ui-grid-cell-contents gridNumber" ng-class="{itm : row.entity.call.itm, selectedOption : row.entity.call.option.code === grid.appScope.selectedInstrument.code}" ng-click="grid.appScope.selectInstrument(row.entity.call.option)" ng-dblclick="grid.appScope.doubleSelectInstrument(row.entity.call.option)">{{row.entity.call ? (row.entity.call.price.v | percentage : 2) : ''}}</div>`
        },
        {
            name: "call.price.d",
            type: "number",
            displayName: "Delta",
            width: "*",
            cellFilter: "number : 3",
            cellTemplate: "<div class=\"ui-grid-cell-contents gridNumber\" ng-class=\"{itm : row.entity.call.itm, selectedOption : row.entity.call.option.code === grid.appScope.selectedInstrument.code}\" ng-click=\"grid.appScope.selectInstrument(row.entity.call.option)\" ng-dblclick=\"grid.appScope.doubleSelectInstrument(row.entity.call.option)\">{{row.entity.call.price.d | number : 3}}</div>"
        },
        {
            name: 'call.oi.interest', type: 'number', displayName: 'o/n Interest', width: '*', cellFilter: 'number : 0',
            headerCellClass: 'pt-5',
            headerCellTemplate: '<span>O/N Int</span> <i class="icon-question text-grey" uib-popover="Overnight Open Interest displays the amount of outstanding contracts in that particular option as at the end of the previous day." popover-trigger="mouseenter" popover-placement="bottom" ></i>',
            cellTemplate: '<div class="ui-grid-cell-contents gridNumber" ng-class="{itm : row.entity.call.itm, selectedOption : row.entity.call.option.code === grid.appScope.selectedInstrument.code}" ng-click="grid.appScope.selectInstrument(row.entity.call.option)" ng-dblclick="grid.appScope.doubleSelectInstrument(row.entity.call.option)">{{row.entity.call.oi | number : 0}}</div>'
        },
        {
            name: "level",
            type: "number",
            displayName: "Strike",
            width: "*",
            headerCellClass: "strike",
            cellClass: "strike",
            cellTemplate: `<div class="ui-grid-cell-contents strike">{{row.entity.level | strike : grid.appScope.chain.code === 'XJO'}}</div>`
        },
        {
            name: "put.option.code",
            type: "string",
            displayName: "Code",
            width: "*",
            headerCellClass: "pt-5",
            headerCellTemplate: `<span>ASX Code</span> <i class="icon-question text-grey" uib-popover="The ASX code is the unique name provided by the exchange for identification purposes." popover-trigger="'mouseenter'" popover-placement="bottom" ></i>`,
            cellTemplate: `<div class="ui-grid-cell-contents" ng-class="{itm : row.entity.put.itm, selectedOption : row.entity.put.option.code === grid.appScope.selectedInstrument.code}" ng-click="grid.appScope.selectInstrument(row.entity.put.option)" ng-dblclick="grid.appScope.doubleSelectInstrument(row.entity.put.option)">{{row.entity.put.option.code}}</div>`
        },
        {
            name: "put.price.p",
            type: "number",
            displayName: "Theo Price",
            width: "*",
            cellFilter: "number : 3",
            visible: true,
            cellTemplate: `<div class="ui-grid-cell-contents gridNumber" ng-class="{itm : row.entity.put.itm, selectedOption : row.entity.put.option.code === grid.appScope.selectedInstrument.code}" ng-click="grid.appScope.selectInstrument(row.entity.put.option)" ng-dblclick="grid.appScope.doubleSelectInstrument(row.entity.put.option)">{{row.entity.put.price.p | number : 3}}</div>`
        },
        {
            name: "put.spread.quote",
            type: "string",
            displayName: "Quote",
            width: "*",
            cellFilter: "number : 0",
            visible: userConfig.livePrices,
            cellTemplate: `<div class="ui-grid-cell-contents gridNumber" ng-class="{itm : row.entity.put.itm, selectedOption : row.entity.put.option.code === grid.appScope.selectedInstrument.code}" ng-click="grid.appScope.selectInstrument(row.entity.put.option)" ng-dblclick="grid.appScope.doubleSelectInstrument(row.entity.put.option)"><div class="chain-quote-cell"><span class="quote-bid">{{(row.entity.put.spread.b | strategyPrice : grid.appScope.priceStrategy : true) || '-'}}</span><span class="quote-divider">/</span><span class="quote-ask">{{(row.entity.put.spread.a | strategyPrice : grid.appScope.priceStrategy : true) || '-'}}</span></div></div>`
        },
        {
            name: "put.price.v",
            type: "number",
            displayName: "Volatility",
            width: "*",
            cellFilter: "percentage : 2",
            cellTemplate: `<div class="ui-grid-cell-contents gridNumber" ng-class="{itm : row.entity.put.itm, selectedOption : row.entity.put.option.code === grid.appScope.selectedInstrument.code}" ng-click="grid.appScope.selectInstrument(row.entity.put.option)" ng-dblclick="grid.appScope.doubleSelectInstrument(row.entity.put.option)">{{row.entity.put ? (row.entity.put.price.v | percentage : 2) : ''}}</div>`
        },
        {
            name: "put.price.d",
            type: "number",
            displayName: "Delta",
            width: "*",
            cellFilter: "number : 3",
            cellTemplate: `<div class="ui-grid-cell-contents gridNumber" ng-class="{itm : row.entity.put.itm, selectedOption : row.entity.put.option.code === grid.appScope.selectedInstrument.code}" ng-click="grid.appScope.selectInstrument(row.entity.put.option)" ng-dblclick="grid.appScope.doubleSelectInstrument(row.entity.put.option)">{{row.entity.put.price.d | number : 3}}</div>`
        },
        {
            name: 'put.oi.interest', type: 'number', displayName: 'o/n Interest', width: '*', cellFilter: 'number : 0',
            headerCellClass: 'pt-5',
            headerCellTemplate: '<span>O/N Int</span> <i class="icon-question text-grey" uib-popover="Overnight Open Interest displays the amount of outstanding contracts in that particular option as at the end of the previous day." popover-trigger="mouseenter" popover-placement="bottom" ></i>',
            cellTemplate: '<div class="ui-grid-cell-contents gridNumber" ng-class="{itm : row.entity.put.itm, selectedOption : row.entity.put.option.code === grid.appScope.selectedInstrument.code}" ng-click="grid.appScope.selectInstrument(row.entity.put.option)" ng-dblclick="grid.appScope.doubleSelectInstrument(row.entity.put.option)">{{row.entity.put.oi | number : 0}}</div>'
        }
    ];
}
